import {useRef, useEffect} from 'react';
// frame devider is value that you want to devide the frame rate to (2 in 60fps => 30 callback per second)
export default (callback, frameDevider) => {
  // Use useRef for mutable variables that we want to persist
  // without triggering a re-render on their change
  const requestRef = useRef();
	const previousTimeRef = useRef();
	const switcher = useRef(frameDevider || 0) // used to track the frame rate
  const animate = time => {
    if (previousTimeRef.current !== undefined) {
			const deltaTime = time - previousTimeRef.current;
			if(switcher.current < frameDevider) {
				switcher.current++;
			} else {
				callback(deltaTime)
				switcher.current = 0;
			}
    }
    previousTimeRef.current = time;
		requestRef.current = requestAnimationFrame(animate);
  }
  
  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Make sure the effect runs only once
}